import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen w-full bg-ink font-sans text-paper" data-id="element-192" data-mp="304a9ub9r4xoe">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-amber focus:px-4 focus:py-2 focus:text-ink" data-id="element-193" data-mp="306ekrd62iwy6">
        Naar de inhoud
      </a>
      <Header data-id="element-194" data-mp="3f1198kjfe9e0" />
      <main id="main" data-id="element-195" data-mp="3f1b16do16qmc">
        <Outlet data-id="element-196" data-mp="3f22lutg3b3xu" />
      </main>
      <Footer data-id="element-197" data-mp="3ezq68mxt15ny" />
    </div>;
}